import { Component, Input, OnInit } from '@angular/core';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'new-feature',
	templateUrl: './new-feature.component.html',
	styleUrls: ['./new-feature.component.scss']
})
/**
 * Component Notes:
 * -Can only be put in a position:relative parent element
 * -Parent element need overflow: visible
 * -Currently only support left placement relative to parent component
 * -Use offset if original position is off (due to the parent has some absolute element/icon)
 * -This is not a sticky popup and NO! I WILL NEVER BE!
 * 
 * OPEN FOR ENHANCEMENT! PLEASE!
 * 
 * @export
 * @class NewFeatureComponent
 * @implements {OnInit}
 */

export class NewFeatureComponent implements OnInit {
	@Input() public featureKey: string;
	@Input() public topOffset: number = 0; // how many pixel to push down
	@Input() public leftOffset: number = 0; // how many pixel to push pn the left

	public hasBeenDismissed: boolean = false;

	// screen position
	public containerLeft: string;
	public containerTop: string;
	public triangleTop: string;

	public ngOnInit(): void {
		this.hasBeenDismissed = localStorage.getItem(this.featureKey) === 'true';
		this.calculatePos();
	}

	public dismiss(event): void {
		event.stopPropagation();
		localStorage.setItem(this.featureKey, 'true');
		this.hasBeenDismissed = true;
	}

	public calculatePos(): void {
		const defaultTopPos = -72; // half of the content size - 18px for first line
		const defaultLeftPos = -255; // content width + the triangle width
		this.containerTop = defaultTopPos + this.topOffset + 'px';
		this.containerLeft = defaultLeftPos - this.leftOffset + 'px';
		this.triangleTop = Math.max(Math.abs(defaultTopPos) - 4 - this.topOffset, 0) + 'px'; // keep the triangle at original position
	}
}
